:host {
  display: block;
  font-size: 16px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  user-select: none;
}

* {
  box-sizing: border-box;
}

$family: 'San Francisco', -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', Avenir, 'Avenir Next', 'Helvetica Neue', 'Segoe UI', Helvetica, Arial, sans-serif;

a {
  color: #fff;
}

.wrapper {
  height: 100%;
  position: relative;
  color: #fff;
  font-family: var(--plyr-font-family, $family);
}
.overlay {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
  height: 100%;

  &.has-link {
    cursor: pointer;
  }

  &:before {
    content: '';
    border-radius: var(--zeudy-player-border-radius, 0);
    opacity: var(--zeudy-player-cta-background-opacity, 0.75);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: var(--zeudy-player-cta-background, #000);
    z-index: -1;
    box-shadow: inset 0 0 100px black;
  }
}

.content {
  width: 80%;
  max-width: 600px;

  & * ~ * {
    margin-top: 22px;
  }
}

button {
  background: var(--plyr-color-main, #000);
  appearance: none;
  padding: 6px 12px;
  align-items: center;
  display: inline-flex;
  border-width: 1px;
  border-color: transparent;
  color: #fff;
  border-radius: 0;
  cursor: pointer;
  font-size: 0.8em;
  border-radius: 0 var(--zeudy-player-cta-border-radius, 0) var(--zeudy-player-cta-border-radius) 0;

  @media screen and (min-width: 700px) {
    padding: 10px 18px;
  }

  &:focus {
    box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px, var(--plyr-color-main, #000) 0px 0px 0px 4px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
    z-index: 1;
  }
  &:focus,
  &:hover {
    outline: none;
  }
}

h1 {
  font-size: 1.5em;
  font-weight: 500;
  margin: 0;
  line-height: 1.1em;
}

.skip,
.rewatch {
  font-size: 0.8em;
  font-weight: 600;
  position: absolute;
  top: 0;
  right: 0;
  padding: 4%;
  cursor: pointer;
}

.rewatch {
  display: inline-flex;
  align-items: center;
  right: auto;
  left: 0;

  .icon {
    margin-right: 5px;
  }
}

p {
  font-size: 0.85em;
  margin: 0;
  margin-top: 1.5em;
  line-height: 1.4em;
  opacity: 0.75;

  &.is-small {
    font-size: 0.85em;
    margin: 1.5em 0px 0px;
    line-height: 0.1em;
    opacity: 0.75;
  }
}

.is-centered {
  text-align: center;
}
